import { Fragment } from "react";
import { readAlpsPillars } from "../../constants/alps";
import { setText } from "../../constants/typography";
import styles from "../../styles/ui/AlpsWords.module.scss";

/*
  Wherever the four pillars appear in running text — "Ascolta, Leggi, Parla,
  Scrivi" — only their initials carry the emphasis, so the acronym spells
  itself out inside the sentence. Bolding all four whole words made the
  paragraph shout; lifting just A·L·P·S makes it read as a brand device.
*/
const PILLARS = readAlpsPillars();
const PATTERN = PILLARS.length
  ? new RegExp(`\\b(${PILLARS.join("|")})\\b`, "g")
  : null;

const AlpsWords = ({ children }) => {
  const text = typeof children === "string" ? setText(children) : children;
  if (!PATTERN || typeof text !== "string") return <>{text}</>;

  const parts = text.split(PATTERN);
  if (parts.length === 1) return <>{text}</>;

  return (
    <>
      {parts.map((part, index) =>
        PILLARS.includes(part) ? (
          <span key={index} className={styles.pillar}>
            <span className={styles.initial}>{part.charAt(0)}</span>
            {part.slice(1)}
          </span>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        )
      )}
    </>
  );
};

export default AlpsWords;
